<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="当前通道" class="EL-Form-Item">
                        <el-select v-model="mainSearchMat.whCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.matCode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.boxBarcode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getStockPickList()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetTop">重置</el-button>
                    </el-form-item>
                </el-col>
                
            </el-form>
        </box>
        <box fill>
            <plabel text="半成品管理">
                <el-button v-authority="'BACK_MENU1_M9_B1'" class="btn-t-edit" @click="insertSemi()">半成品入库</el-button>
                <el-button v-authority="'BACK_MENU1_M9_B2'" class="btn-t-edit" @click="getVirtualInventory()">半成品库存</el-button>
                <el-button v-authority="'BACK_MENU1_M9_B3'" class="btn-t-edit" @click="onlineUse()">回退</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getStockPickList" :data="nextData.data" pagination :nowPage.sync="mainSearchMat.nowPage" :pageSize.sync="mainSearchMat.pageSize" :total.sync="nextData.total" @selectionChange="selectNext">
                <el-table-column type="selection" align="center" :selectable="checkboxSelect" />
                <el-table-column label="通道编号" align="center" prop="whCode" />
                <el-table-column label="物料编号" align="center" prop="matCode" />
                <el-table-column label="物料描述" align="center" prop="matName" />
                <el-table-column label="数量" align="center" prop="matQuan" />
                <el-table-column label="批次号" align="center" prop="batchNo" />
                <el-table-column label="库位" align="center" prop="lcCode" />
                <el-table-column label="包装箱号" align="center" prop="boxBarcode" />
                <!-- <el-table-column label="规值" align="center" prop="matSpecs" /> -->
                <el-table-column label="是否单品管理" align="center" prop="singletonFlag" v-if="false"/>
                <el-table-column label="入库时间" align="center" prop="matCreateTime" width="150"/>
                <!-- <el-table-column label="产品状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">冻结</span>
                        <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">作废</span>
                    </template>
                </el-table-column> -->
              <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.receiptResult == '40'">半成品入库</span>
                </template>
              </el-table-column>
                <!-- <el-table-column label="位置类型" align="center" prop="lrPointType">
                    <template slot-scope="scope">
                        <span>{{ scope.row.lrPointType | filterLrPointType}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="地面位置" align="center" prop="routerCode"></el-table-column> -->
                <el-table-column label="送达时间" align="center" prop="updateTime" width="150"></el-table-column>
            </h-table>
        </box>
        <plabel text="半成品入库" class="FontSize-8">
        </plabel>
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearch.whCode" placeholder="请选择" @change="getStockPickList(), getSemiFinishedProductPage()" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matCode" placeholder="请输入" @change="returnMatSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.boxBarcode" placeholder="请输入" @change="returnMatSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="状态" class="EL-Form-Item">
                        <el-select v-model="mainSearch.status" placeholder="请选择" clearable="clearable">
                            <el-option label="默认（创建、驳回）" value="CREATE,REJECT" />
                            <el-option label="创建" value="CREATE" />
                            <el-option label="待质检" value="INSPECTED" />
                            <el-option label="质检完成" value="QUALITYCOMPLETED" />
                            <el-option label="待上架" value="WAIT" />
                            <el-option label="驳回" value="REJECT" />
                            <el-option label="上架中" value="UPPERING" />
                            <el-option label="驳回已接收" value="RECEiIVE" />
                            <el-option label="完成" value="CONFIRM" />
                            <el-option label="关闭" value="CLOSE" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getSemiFinishedProductPage">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetMain">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <plabel>
                <el-button v-authority="'BACK_MENU1_M6_B1'" class="btn-t-edit" @click="closeTask()"> 任务关闭 </el-button>
                <el-button v-authority="'BACK_MENU1_M6_B3'" class="btn-t-edit" type="primary" @click="prints()">单据打印</el-button>
                <el-button v-authority="'BACK_MENU1_M6_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getSemiFinishedProductPage" :data="mainData.data" pagination :nowPage.sync="mainSearch.nowPage" :pageSize.sync="mainSearch.pageSize" :total.sync="mainData.total" @selectionChange="selectMain">
                <el-table-column type="selection" align="center" :selectable="checkboxSelect">
                </el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="入库单号" align="center" prop="sfpCode">
                </el-table-column>
                <el-table-column label="状态" align="center" prop="sfpState">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sfpState == 'CREATE'">创建</span>
                        <span v-if="scope.row.sfpState == 'WAIT'">待上架</span>
                        <span v-if="scope.row.sfpState == 'REJECT'">驳回</span>
                        <span v-if="scope.row.sfpState == 'UPPERING'">上架中</span>
                        <span v-if="scope.row.sfpState == 'RECEiIVE'">驳回已接收</span>
                        <span v-if="scope.row.sfpState == 'CONFIRM'">完成</span>
                        <span v-if="scope.row.sfpState == 'CLOSE'">关闭</span>
                    </template>
                </el-table-column>
                 <el-table-column label="入库数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="驳回原因" align="center" prop="reasonsRejection">
                </el-table-column>
                <el-table-column label="操作人员" align="center" prop="person">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                </el-table-column>
                <el-table-column label="修改时间" align="center" prop="updateTime">
                </el-table-column>
                <el-table-column label="操作" min-width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU1_M6_B5'" class="btn-t-edit" @click="detailDialog(scope.row.sfpCode)">
                            明细
                        </el-button>
                    </template>
                </el-table-column>
            </h-table>
        </box>
        <!-- 线上 物料退回 -->
        <el-dialog :title="titleType" :visible.sync="onlineDialog" class="infoDialog" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="100px" :model="onlineInfo" ref="onlineInfo" :rules="returnInfoRules">
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                            <el-input v-model="onlineInfo.matCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="数量" prop="matQuan" class="EL-Form-Item">
                            <el-input v-model="onlineInfo.matQuan" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="批次号" prop="batchNo" class="EL-Form-Item">
                            <el-input v-model="onlineInfo.batchNo" placeholder="请输入" :disabled="disabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="包装箱号" prop="boxBarcode" class="EL-Form-Item">
                            <el-input v-model="onlineInfo.boxBarcode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="规值" prop="matSpecs" class="EL-Form-Item">
                            <el-input v-model="onlineInfo.matSpecs" placeholder="请输入" :disabled="disabled"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="入库时间" prop="matCreateTime" class="EL-Form-Item">
                            <el-date-picker v-model="onlineInfo.matCreateTime" type="date" value-format="yyyy-MM-dd" placeholder="入库时间" v-bind:disabled="disabled">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer EL-Form-Item">
                <el-button @click="operationOnline" class="btn-t-edit" size="small">保 存</el-button>
                <el-button @click="closeonlineDailog" type="info" size="small">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 生产退料 -->
        <el-dialog title="半成品入库" :visible.sync="dialogShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="100px" :model="returnInfo" ref="returnInfo" :rules="returnInfoRules">
                    <el-col :lg="5" :xl="5" v-if="this.resd==0">
                        <el-form-item label="当前通道" prop="whCode" class="EL-Form-Item">
                            <el-select v-model="returnInfo.whCode" clearable="clearable" placeholder="请选择">
                                <el-option v-for="item in BoxBarcodeList" :key="item.whId" :value="item.whCode" :label="item.whCode">{{ item.whCode }}-{{ item.whName }}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="this.resd==0">
                        <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                            <el-input v-model="returnInfo.matCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="this.resd==0">
                        <el-form-item label="数量" prop="boxQuan" class="EL-Form-Item">
                            <el-input v-model="returnInfo.boxQuan" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="this.resd==0 ">
                        <el-form-item label="包装箱号" prop="boxBarcode" class="EL-Form-Item">
                            <el-select v-model="returnInfo.boxBarcode" clearable="clearable" placeholder="请选择">
                                <el-option v-for="(item, index) in BoxBarcodeList" :key="index" :value="item.boxBarcode" :label="item.boxBarcode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="this.resd==1 && this.fcCode == 'SXC'">
                        <el-form-item label="配送方式" class="EL-Form-Item">
                            <el-select v-model="returnInfo.distrType" placeholder="请选择">
                                <el-option label="AGV配送" value="10" />
                                <el-option label="人工配送" value="20" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="5" :xl="5" v-if="this.resd==1">
                        <el-form-item label="库位" prop="lcCode" class="EL-Form-Item" v-if="returnInfo.distrType == '10'">
                            <el-select v-model="returnInfo.lcCode" clearable="clearable" placeholder="请选择">
                                <el-option v-for="(item, index) in sysLineRouterList" :key="index" :value="item.lrRealCode" :label="item.lrName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <!-- <el-col :lg="5" :xl="5" v-if="this.resd==1 || this.resd==0 ">
                        <el-form-item label="退回原因" prop="wtName" class="EL-Form-Item">
                            <el-select v-model="returnInfo.wtName" clearable="clearable" placeholder="请选择">
                                <el-option v-for="item in warnTypeList" :key="item.wtId" :value="item.wtName" :label="item.wtName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <!-- <el-col :lg="5" :xl="5" v-if="this.resd==1 ">
                        <el-form-item label="箱体高度" prop="boxHeight" class="EL-Form-Item">
                            <el-select v-model="returnInfo.boxHeight" placeholder="请选择" clearable="clearable" filterable>
                                <el-option label="一层" value="1" />
                                <el-option label="二层" value="2" />
                                <el-option label="三层" value="3" />
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :lg="4" :xl="4" v-if="this.resd==0">
                        <el-button class="btn-t-edit" @click="getInventoryByBoxcode()">添加</el-button>
                    </el-col>
                </el-form>
            </div>
            <div>
                <h-table :style="$popups.harvestRecordStyle(0.63)" :headerCellStyle="mainData.headerCellStyle" :data="returnList">
                    <el-table-column label="通道编号" align="center" prop="whCode">
                    </el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode">
                    </el-table-column>
                    <el-table-column label="物料描述" align="center" prop="matName">
                    </el-table-column>
                    <el-table-column label="原有数量" align="center" prop="matQuan">
                    </el-table-column>
                    <el-table-column label="退料数量" align="center" prop="matQuan">
                    </el-table-column>
                    <el-table-column label="批次号" align="center" prop="batchNo">
                    </el-table-column>
                    <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                    </el-table-column>
                    <!-- <el-table-column label="备注" align="center" prop="remark">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remark">
                            </el-input>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column label="退回原因" align="center" prop="wtName">
                    </el-table-column> -->
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeDailog" type="info" class="btn-t-info">关 闭</el-button>
                <el-button :loading="insertStockReturnMats" @click="insertSemiFinishedProduct()" class="btn-t-edit" size="small">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 添加通道库存 -->
        <el-dialog title="添加通道库存" :visible.sync="dialogShows" :close-on-click-modal="false" :show-close="false" class="fromDialog" :style="$popups.popups(0.8,0.9)">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="100px" :model="returnInfo" ref="returnInfo" :rules="returnInfoRules">
                    <el-col :lg="5" :xl="5" v-if="insetadd==1">
                        <el-form-item label="当前通道" prop="whCode" class="EL-Form-Item">
                            <el-select v-model="returnInfo.whCode" clearable="clearable" placeholder="请选择">
                                <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode">{{ item.whCode }}-{{ item.whName }}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==0">
                        <el-form-item label="物料编号" prop="matCodes" class="EL-Form-Item">
                            <el-input v-model="wipMatCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :lg="5" :xl="5" v-if="insetadd==0">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="returnInfo.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions01"></el-date-picker>
                    </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==0">
                        <el-form-item label="结束日期" class="EL-Form-Item">
                            <el-date-picker v-model="returnInfo.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions1"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==1">
                        <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                            <el-input v-model="returnInfo.matCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==1">
                        <el-form-item label="物料描述" prop="boxQuan" class="EL-Form-Item">
                            <el-input v-model="returnInfo.matName" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==1">
                        <el-form-item label="数量" prop="boxQuan" class="EL-Form-Item">
                            <el-input v-model="returnInfo.boxQuan" placeholder="请输入"></el-input>
                        </el-form-item>
                        <!-- </el-col>
                      <el-col :lg="4" :xl="4" v-if="insetadd==0">
                        <el-button class="btn-t-edit" @click="insetadd=1,returnLists=[]">手动添加</el-button>
                    </el-col> -->
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <el-button class="btn-t-edit" v-if="insetadd==0" @click="getBoxBarcodeList()">查询</el-button>
                            <el-button class="btn-t-edit" v-if="insetadd==1" @click="getInventory()">添加</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5" v-if="insetadd==1">
                        <el-form-item label="规值" prop="boxQuan" class="EL-Form-Item">
                            <el-input v-model="returnInfo.matSpecs" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div>
                <h-table :style="$popups.harvestRecordStyle(0.69)" :headerCellStyle="mainData.headerCellStyle" :data="wipOutInventoryList" pagination :nowPage.sync="returnSearch.nowPage" :pageSize.sync="returnSearch.pageSize" :total.sync="returnSearch.total" @selectionChange="selectWipOutInventory">
                    <el-table-column type="selection" align="center"></el-table-column>
                    <el-table-column label="通道编号" align="center" prop="whCode">
                    </el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode">
                    </el-table-column>
                    <el-table-column label="物料描述" align="center" prop="matName">
                    </el-table-column>
                    <el-table-column label="物料数量" align="center" prop="matQuan">
                        <template slot-scope="scope">
                            <el-input size="mini" v-model="scope.row.matQuan"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="批次号" align="center" prop="batchNo">
                    </el-table-column>
                    <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                    </el-table-column>
                    <el-table-column label="规值" align="center" prop="matSpecs">
                    </el-table-column>
                    <el-table-column label="时间" align="center" prop="createTime">
                    </el-table-column>
                    <!-- <el-table-column label="订单" align="center" prop="orderCode">
                    </el-table-column> -->
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeDailogs" type="info" class="btn-t-info">关 闭</el-button>
                <el-button :loading="insertInventoryLists" @click="insertInventoryList()" class="btn-t-edit" size="small">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 生产退料明细 -->
        <el-dialog title="生产退料明细" :visible.sync="detailShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
            <h-table :headerCellStyle="mainData.headerCellStyle" :style="$popups.harvestRecordStyle(0.75)" @pageChange="getStockReturnMatList" :data="detailData.data" pagination :nowPage.sync="detailData.pageNum" :pageSize.sync="detailData.pageSize" :total.sync="detailData.total">
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="退料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo">
                </el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="退料单号" align="center" prop="sfpCode">
                </el-table-column>
                <el-table-column label="退料状态" align="center" prop="spStatus">
                    <template slot-scope="scope">
                        <span v-if="scope.row.spStatus == 'CREATE'">创建</span>
                        <span v-if="scope.row.spStatus == 'INSPECTED'">待质检</span>
                        <span v-if="scope.row.spStatus == 'QUALITYCOMPLETED'">质检完成</span>
                        <span v-if="scope.row.spStatus == 'WAIT'">待上架</span>
                        <span v-if="scope.row.spStatus == 'REJECT'">驳回</span>
                        <span v-if="scope.row.spStatus == 'UPPERING'">上架中</span>
                        <span v-if="scope.row.spStatus == 'RECEiIVE'">驳回已接收</span>
                        <span v-if="scope.row.spStatus == 'CONFIRM'">完成</span>
                        <span v-if="scope.row.spStatus == 'CLOSE'">关闭</span>
                    </template>
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remark">
                </el-table-column>
                <el-table-column label="操作人员" align="center" prop="person">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                </el-table-column>
                <el-table-column label="修改时间" align="center" prop="updateTime">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeDetailDailog" type="info" class="btn-t-info">关 闭</el-button>
                <!-- <el-button @click="closeDetailDailog" class="btn-t-edit">确 认</el-button> -->
            </div>
        </el-dialog>

        <!--重新提交-->
        <el-dialog title="重新提交" :visible.sync="resubmitShow" class="fromDialog" :style="$popups.popups(0.35,0.28)" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="80px" :model="returnInfo" ref="returnInfo" :rules="returnInfoRules">
                    <el-col :lg="12" :xl="12">
                        <el-form-item label="配送方式" class="EL-Form-Item">
                            <el-select v-model="returnInfo.distrType" placeholder="请选择">
                                <el-option label="AGV配送" value="10" />
                                <el-option label="人工配送" value="20" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12" :xl="12">
                        <el-form-item label="库位" prop="lcCode" class="EL-Form-Item" v-if="returnInfo.distrType == '10'">
                            <el-select v-model="returnInfo.lcCode" clearable="clearable" placeholder="请选择">
                                <el-option v-for="(item, index) in sysLineRouterList" :key="index" :value="item.lrRealCode" :label="item.lrRealCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12" :xl="12">
                        <el-form-item label="退回原因" prop="wtName" class="EL-Form-Item">
                            <el-select v-model="returnInfo.wtName" clearable="clearable" placeholder="请选择">
                                <el-option v-for="item in warnTypeList" :key="item.wtId" :value="item.wtName" :label="item.wtName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="resubmitShow=false" type="info" class="btn-t-info">关 闭</el-button>
                <el-button :loading="insertStockReturnMats" @click="resubmit()" class="btn-t-edit" size="small">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 虚拟库存 -->
        <el-dialog title="半成品库存" :visible.sync="dialogShowVirtual" :close-on-click-modal="false" :show-close="false" class="fromDialog" :style="$popups.popups(0.8,0.9)">
            <div>
                <el-form label-position="right" label-width="80px" class="EL-Form">
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-input v-model="tableMatName" placeholder="请输入" style="width:120px" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
                <div style="padding:6px 0; float:left">
                    <!-- <el-button class="btn-t-edit" @click="doFilter()">搜索</el-button> -->
                    <el-button class="btn-t-edit" @click="getVirtualInventory()">搜索</el-button>
                </div>
                <div style="padding:10px 0; float:right">
                    <el-button @click="insertstock()" class="btn-t-edit">生成半成品库存</el-button>
                </div>

                <h-table v-loading="loading" :style="$popups.harvestRecordStyle(0.68)" :headerCellStyle="mainData.headerCellStyle" :data="virtualInventoryList"  @selectionChange="selection">
                    <!--  @selectionChange="selection" -->
                    <el-table-column type="selection" align="center"></el-table-column>
                    <el-table-column label="通道编号" align="center" prop="whCode" />
                    <el-table-column label="物料编号" align="center" prop="matCode" />
                    <el-table-column label="物料描述" align="center" prop="matName" />
                    <el-table-column label="箱号" align="center" prop="boxBarcode"/>
                    <el-table-column label="数量" align="center" prop="matQuan" />
                    <!-- <el-table-column label="批次号" align="center" prop="batchNo" /> -->
                    <el-table-column label="批次号" align="center" prop="batchNoNew" width="150px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.batchNoNew"></el-input>
                        </template>
					</el-table-column>
                    <el-table-column label="库位" align="center" prop="lcCode" />
                    <el-table-column label="每箱数量" align="center" prop="boxNumber">
                         <template slot-scope="scope">
                             <el-input v-model="scope.row.boxNumber" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                         </template>
                    </el-table-column>
                    <el-table-column label="箱数" align="center" prop="boxCount" >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.boxCount">
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="入库时间" align="center" prop="matCreateTime" />
                    <el-table-column label="产品状态" align="center" width="120px">
                        <template slot-scope="scope">
                            <span>{{scope.row.wiStatus | filterStatus }}</span>
                            <!-- <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                            <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
                            <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                            <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                            <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span> -->
                        </template>
                    </el-table-column>
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="dialogShowVirtual = false,virtualInventoryList = []" type="info" class="btn-t-info">关 闭</el-button>
                <!-- <el-button :loading="insertInventoryLists" @click="insertInventoryList()" class="btn-t-edit" size="small">确 认</el-button> -->
            </div>
        </el-dialog>

         <!-- 添加单圈库存 -->
        <el-dialog title="添加单圈库存" :visible.sync="dialogShowSingleStock" :close-on-click-modal="false" :show-close="false" class="fromDialog" :style="$popups.popups(0.4,0.3)">
            <div>
                <div>
                    <el-form label-position="right" label-width="80px" class="EL-Form">
                        <el-col :lg="12" :xl="12">
                            <el-form-item label="箱号" class="EL-Form-Item">
                                <el-input v-model="tableSingle" placeholder="请输入" style="width:200px" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xl="12">
                            <el-form-item class="EL-Form-Item">
                                <el-button class="btn-t-edit" @click="getSingleInventory()" style="margin:5px 0">添加</el-button>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </div>
                <div style="overflow-y: scroll;height: 100px;width: 100%;">
                    <el-tag
                        class="breaditem"
                        v-for="(item,index) in singleStockList"
                        :key="index"
                        @close="handleClose(item)"
                        closable
                        :disable-transitions="false"
                    >
                    {{item}} 
                    </el-tag>
                </div>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="dialogShowSingleStock = false,singleStockList = [],tableSingle = ''" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="insertSinglestock()" class="btn-t-edit" size="small">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 调整批次-->
        <el-dialog title="调整批次" :visible.sync="dialogShowbatch" :close-on-click-modal="false" :show-close="false" class="fromDialog" :style="$popups.popups(0.2,0.2)">
            <div>
                <el-form label-position="right" label-width="80px" class="EL-Form">
                    <el-col :lg="5" :xl="5">
                         <el-form-item label="成本中心" class="EL-Form-Item">
                            <el-select v-model="tablecause"  style="width:200px" clearable="clearable" filterable placeholder="请选择" >
                                <!-- <el-option :value="item.reasonCode" :label="item.reasonCode +'-'+ item.reasonDescription" :key="index" v-for="(item, index) in transationReasonData"></el-option> -->
                                <el-option value="2352" label="2352-status adjustment" key="1" ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="dialogShowbatch = false,tablecause = '',updateListAll = []" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="updateVirtualBatch()" class="btn-t-edit" size="small">确 认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="打印" :visible.sync="printShow" width="1500px" :close-on-click-modal="false">
            <v-print :doPrint.sync="print">
                <div id="demo" class="demo">
                <div>
                    <div style="margin-left: -1200px; margin-top: 50px">
                    {{ timeDate }}
                    </div>
                    <div style="margin-right: -1800px; margin-top: 50px">
                    <el-button size="small" type="primary" @click="clearPrintData">
                        清空数据
                    </el-button>
                    </div>
                    <div style="font-size: 30px;font-weight: 600;margin-top: 20px;text-align: center;">
                    ATC通道退料单
                    </div>
                    <div class="div" style="margin-top: 10px; font-size: 20px">
                    <!-- <span>工序：</span> -->
                    <!-- <span>通道：{{ whCodes }}</span>
                    <span>班次：</span> -->
                    <span>通道名称：{{person}}</span>
                    <span>退料日期：{{ timeDate }}</span>
                    <span>通道班长：</span>
                    <span>仓管员：</span>
                    </div>
                    <div class="table">
                    <table width="100%" border="1" cellpadding="0" cellspacing="0">
                        <tr>
                        <th>序号</th>
                        <th>零件代码</th>
                        <th>数量</th>
                        <th>退料批次</th>
                        <th>实收数量</th>
                        <!-- <th>库位</th> -->
                        <th>备注</th>
                        </tr>
                        <tr v-for="(item, index) in printList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.matCode }}</td>
                        <td>{{ item.matQuan }}</td>
                        <td>{{ item.batchNo }}</td>
                        <td></td>
                        <td></td>
                        <!-- <td>{{ item.matQuan }}</td> -->
                        </tr>
                    </table>
                    </div>
                    <!-- <div class="div" style="margin-top: 10px; font-size: 20px">
                    <span>总数量：{{ summarySumNumber }}</span>
                    <span>箱数：{{ boxNumber }}</span>
                    </div> -->
                </div>
                </div>
            </v-print>

        <div style="margin-top: 50px;height:80px">
            <el-button class="btn-t-edit" @click="printShow = false">取消</el-button>
            <el-button class="btn-t-edit" @click="(print = true), (printShow = false)">打印</el-button>
        </div>
        </el-dialog>

    
        <!-- <el-dialog :visible.sync="printShow" top="5px" width="1200px" :close-on-click-modal="false">
            <v-print :doPrint.sync="print">
                <div style="color: black">
                    <el-row type="flex" align="middle">
                        <el-col :lg="4" :xl="4" :offset="10">
                            <h1>虚拟库存</h1>
                        </el-col>
                        <el-col :lg="4" :xl="4" :offset="6">
                            <el-button class="btn-t-info" type="info" @click="printShow = false;">取消</el-button>
                            <el-button class="btn-t-edit" @click="print = true; printShow = true">打印</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :lg="4" :xl="4" :offset="10">
                            {{ checkPrint.hour }}
                        </el-col>
                    </el-row>
                </div>
                <div style="color: black">
                    <table width="100%" cellspacing="0">
                        <tr>
                            <th v-for="(item,index) in checkPrint.head" :key="index">{{item}}</th>
                        </tr>
                        <tr v-for="(item,index) in virtualInventoryList" :key="index">
                            <td>{{item.whCode}}</td>
                            <td>{{item.matCode}}</td>
                            <td>{{item.matName}}</td>
                            <td>{{item.matQuan}}</td>
                            <td></td>
                            <td>{{item.batchNo}}</td>
                            <td>{{item.lcCode}}</td>
                            <td>{{item.boxBarcode}}</td>
                            <td>{{item.matSpecs}}</td>
                            <td>{{item.matCreateTime}}</td>
                            <td>{{item.wiStatus | filterStatus}}</td>
                        </tr>
                    </table>
                </div>

                <div v-if="nextData.data.length" style="color: black; margin-top: 100px">
                    <el-row>
                        <el-col :lg="4" :xl="4" :offset="10">
                            <h1>通道库存</h1>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :lg="4" :xl="4" :offset="10">
                            {{ checkAisle.hour }}
                        </el-col>
                    </el-row>
                </div>
                <div v-if="nextData.data.length" style="color: black; padding-bottom: 50px">
                    <table width="100%" cellspacing="0">
                        <tr>
                            <th v-for="(item,index) in checkAisle.head" :key="index">{{item}}</th>
                        </tr>
                        <tr v-for="(item,index) in nextData.data" :key="index">
                            <td>{{item.whCode}}</td>
                            <td>{{item.matCode}}</td>
                            <td>{{item.matName}}</td>
                            <td>{{item.matQuan}}</td>
                            <td></td>
                            <td>{{item.batchNo}}</td>
                            <td>{{item.lcCode}}</td>
                            <td>{{item.boxBarcode}}</td>
                            <td>{{item.matSpecs}}</td>
                            <td>{{item.matCreateTime}}</td>
                            <td>{{item.recordDate}}</td>
                        </tr>
                    </table>
                </div>
            </v-print>
        </el-dialog> -->
    </div>
</template>

<script>
    import vPrint from 'syl-vue-printer'
    import plabel from '../../components/public/plabel.vue';
    import moment from 'moment'
    import printJS from "print-js";
    import htmlToPdf from "@/libs/htmlToPdf";
    export default {
        components: {
            plabel,
            vPrint
        },
        name: "MaterialOnlineOrReturn",
        data() {
            return {
                //虚拟库存多选集合
                checkLists: [],
                titleType: "",
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },

                nextData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },

                printObj: {
                    id: "demo",
                    popTitle: "",
                },

                // 筛选条件
                mainSearch: {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    sfpCode: "",
                    matCode: "",
                    boxBarcode: "",
                    status: "CREATE,REJECT",
                    matSpecs: "",
                    matLenValue: "",
                    date: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                },
                // 筛选条件
                mainSearchMat: {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    sfpCode: "",
                    matCode: "",
                    boxBarcode: "",
                    status: "",
                    matSpecs: "",
                    matLenValue: "",
                    lrPointType: "",
                    date: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    lcCode: ''
                },
                whCodeId: "",
                warehouseList: [],
                warnTypeList: [],
                boxSpecs: [],
                resd: 0,
                //多选
                checkListMain: [],
                checkListMains: [],
                checkListMainss: [],
                //工厂信息
                factory: {},

                //箱号
                BoxBarcodeList: [],
                BoxBarcodeLists: [],
                returnInfoRules: {},

                //退料料箱
				returnSearch: {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
				},
                returnInfo: {
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    matCodes: "",
                    whCodeBack: "",
                    lcCode: "",
                    distrType: "",
                    wtName: "",
                    boxQuan: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    beginTime: "",
                    boxHeight: "",
                    date: [],
                },
                returnList: [],
                returnLists: [],
                returnListss: [],
                dialogShow: false,
                dialogShows: false,
                onlineDialog: false,
                resubmitShow: false,
                //在线物料退回
                onlineInfo: {
                    whCode: localStorage.getItem("whCode") || "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    matCode: "",
                    boxBarcode: "",
                    matQuan: "",
                    batchNo: "",
                    matSpecs: "",
                    matLenValue: "",
                    position: "",
                    validityMonth: "",
                    matCreateTime: "",
                },
                disabled: false,

                //详情
                detailShow: false,
                detailData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    sfpCode: "",
                },
                dataList: [],
                insetadd: 0,

                person: localStorage.getItem("user"),
                fcCode: localStorage.getItem("fcCode"),

                downloadLoading: false, //下载中
                downloadLoadingMat: false, //下载中
                insertStockPrintBarcodes: false,
                insertInventoryLists: false,
                insertStockReturnMats: false,


                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                //汇总总数量
                summarySumNumber: 0,
                //总箱数
                boxNumber: 0,
                //总数量
                sumNumber: 0,

                //记录判断
                otherRecordList: [],

                //打印
                print: false,
                printShow: false,
                checkPrint:{
                    // 表格的时间
                    hour: moment(new Date).format("yyyy-MM-DD HH:MM:SS"),
                    // 表头
                    head: ["通道","物料编号","物料描述","数量","实际数量","批次号","库位","包装箱号","规值","入库时间","产品状态"],
                    data: [],
                },
                checkAisle:{
                    // 表格的时间
                    hour: moment(new Date).format("yyyy-MM-DD HH:MM:SS"),
                    // 表头
                    head: ["通道","物料编号","物料描述","数量","实际数量","批次号","库位","包装箱号","规值","入库时间","记录时间"],
                },
                printList: [],
                timeDate: '',

                workCenter: '', //成本中心

                dialogShowVirtual: false,
                virtuallcCode: "",
                virtualInventoryList: [],
                dialogShowSingleStock: false,
                tableSingle:"",//圈号
                singleStockList:[],

                dialogShowbatch: false,
                tablecause:"2352",//原因
                //交易原因
                transationReasonData: [],
                updateListAll:[],

                virtualInventoryAllList: [],

                //agv搬运产线点位
                sysLineRouterList: [],

                //退料通道库存
                wipOutInventoryList: [],
                wipMatCode: '',
                //选中的库存
                wipOutSelectList: [],
                // 输入框延时加载
                isSetTimeout: null,
                loading: true,

                tableMatName:"",//物料编号-虚拟库存

                //判断是否共享通道
                shareWhCodeFlag:false,
                //共享库位集合
                shareLcCodeList:[],
                //共享库位
                shareLcCodes: "",
                timer:"",
            };
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },

            pickerOptions1() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.returnInfo.date[0]) {
                            return time.getTime() < new Date(_this.returnInfo.date[0]);
                        }
                    }
                }
            },
            pickerOptions01() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.returnInfo.date[1]) {
                            return time.getTime() > new Date(_this.returnInfo.date[1]);
                        }
                    }
                }
            },
        },
        watch: {
            mainSearchMat: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getStockPickList(newVal);
                    }, 1000);
                },
                deep: true,
            },
            // nextData: {
            //     handler(newVal) {
            //         clearTimeout(this.isSetTimeout)
            //         this.isSetTimeout = setTimeout(() => {
            //             this.getStockPickList();
            //         }, 25000);
            //     },
            //     deep: true,
            // }
        },
        filters:{
            filterStatus(type){
                if (type == "NORMAL") {
                    return "正常"
                }else if (type == "FREEZE") {
                    return "拣配中"
                }else if (type == "OVERTIME") {
                    return "过期"
                }else if (type == "DELETE") {
                    return "作废"
                }else if (type == "AGFREEZE") {
                    return "冻结"
                }
            },
            filterLrPointType(type){
                if (type == "10") {
                    return "装配"
                }else if (type == "20") {
                    return "锻圈"
                }
            }
        },

        methods: {
            handleClose(item) {
                this.singleStockList.splice(this.singleStockList.indexOf(item), 1);
            },
            tabClick(row) {
                this.$set(row, "clicktext", true);
            },
            closetask(data){
                this.$set(data, "clicktext", false);
            },
            doFilter(){
                
                if(this.tableMatName == "" || this.tableMatName == null){

                    //this.getVirtualInventory();
                    this.virtualInventoryList = this.virtualInventoryAllList;

                }else{
                let list = [];
                this.virtualInventoryAllList.forEach((item)=>{

                    if( item.matCode.indexOf(this.tableMatName) >= 0){
                        list.push(item)
                    }

                this.virtualInventoryList = list

                })
                }
            },
            returnMaterial(){
                if (this.checkLists.length == 0) {
                    this.$message({
                        message: "请选择要退料的物料",
                        type: "warning",
                    });
                    return;
                }
                this.getLcCodeAllByWhCode();
                // this.getPointByBoxBarcode();
                // var map = [];
                // this.dataList.forEach((e) => {
                //     map.push(e.boxBarcode);
                // })
                // const res = this.checkLists.every(e => {
                //     if (map.indexOf(e.boxBarcode) > 0) {
                //         this.$message({
                //             message: "该物料已退料",
                //             type: "warning",
                //         });
                //         return false;
                //     } else {
                //         return true;
                //     }
                // })
                // if (res == false) {
                //     return false;
                // }
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    date: [],
                    whCodeBack: "",
                    wtName: "",
                    lcCode: "",
                    distrType: "10"
                };
                this.resd = 1;
                this.dialogShow = true;
                this.returnList = this.checkLists;
            },
            single(){
                if (this.checkLists.length == 0) {
                    this.$message({
                        message: "请选择要保存的数据！",
                        type: "warning",
                    });
                    return false;
                }
                if(this.checkLists.length > 1){
                    this.$message({
                        message: "只能选择一条数据进行保存！",
                        type: "warning",
                    });
                    return false;
                }
                this.dialogShowSingleStock = true

            },
            getSingleInventory(){
                if(this.tableSingle == "" || this.tableSingle == null){
                    this.$message({
                        message: "圈号不能为空！",
                        type: "warning",
                    });
                    return false;
                }
            
                this.singleStockList.unshift(this.tableSingle);

                
            },
            //添加单圈库存
            insertSinglestock(){
                if (this.singleStockList.length == 0) {
                    this.$message({
                        message: "请添加需要退库的单圈库存！",
                        type: "warning",
                    });
                    return false;
                }else{
                    this.$confirm("是否确认添加库存?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        let boxBarcodes = "";
                        this.singleStockList.forEach((element) => {
                            boxBarcodes = boxBarcodes + element+ ",";
                        });
                        this.$http
                            .request({
                                url: "/api/inventory/insertSinglestock",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    whCode: localStorage.getItem("whCode"),
                                    boxBarcodes: boxBarcodes,
                                },
                                data: this.checkLists,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.setReturnInfo();
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "SysLocation：添加库存成功";

                                    //退料条码打印
                                    var whinventoryList = resp.data;
                                    for (var index in whinventoryList) {
                                        var whData = whinventoryList[index];
                                        var produceTime = moment(whData.createTime).format("YYYYMMDD");
                                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                        // var qrCode = "T/" + "" + "/" + whData.boxBarcode + "/" + whData.matCode + "/" +
                                        //     whData.matQuan + "/" + whData.matSpecs + "/" + whData.newBatchNo +
                                        //     "/" + produceTime + "/" + whData.boxHeight;

                                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                        var qrCode = whData.boxBarcode + "," + whData.orderCode + "," + whData.whCode + "," +
                                            whData.matCode + "," + whData.matQuan + "," + whData.matSpecs +
                                            "," + whData.newBatchNo + "," + produceTime + "," + ",,,";
                                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                        var barcodeData = {
                                            boxBarcode: whData.boxBarcode,
                                            poCode: whData.orderCode,
                                            prodCode: whData.matCode,
                                            prodName: whData.matName,
                                            batchNo: whData.batchNo,
                                            count: whData.matQuan,
                                            checkPerson: localStorage.getItem("empNumber"),
                                            date: produceTime,
                                            matSpecs: whData.matSpecs,
                                            whCode: whData.whCode,
                                            qrCode: qrCode,
                                            printTime: printTime,
                                        }
                                        this.$printer.printWMSReturnBarcode(barcodeData);
                                    }
                                    this.dialogShowSingleStock = false;
                                    this.tableSingle = "";
                                    this.singleStockList = [];
                                    //刷新数据
                                    this.getVirtualInventory();
																		
                                    this.getStockPickList();
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "SysLocation：添加库存失败";
                                }
                                this.logContent = JSON.stringify(this.checkLists);
                                this.systemLog();
                            })
                    })
                    .catch(() => {
                        this.insertInventoryLists = false;
                        this.$message({
                            type: "info",
                            message: "已取消保存",
                        });
                    });    
                }
            },
            handleDown() {
                // console.log(document.querySelector("#demo"));
                htmlToPdf.downloadPDF(document.querySelector("#demo"), "X-R控制图");
            },
            //虚拟库存添加库存
            insertstock(){
                if (this.checkLists.length == 0) {
                    this.$message({
                        message: "请选择要保存的数据！",
                        type: "warning",
                    });
                    return false;
                }
                if(this.mainSearchMat.fcCode=='DLN'){
                    const res = this.checkLists.every(e => {
                    if (e.boxBarcode != e.boxBarcodeNew) {
                        if(e.boxCount >1){
                            this.$message({
                                message: "数量不能大于1！",
                                type: "warning",
                            });
                            return false;
                        }else if(e.boxNumber >1){
                            this.$message({
                                message: "箱数不能大于1！",
                                type: "warning",
                            });
                            return false;
                        }else {
                        return true;
                    }
                    }else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                }
                const res = this.checkLists.every(e => {
					console.log("boxCount: ",e.boxCount)
					console.log("boxNumber: ",e.boxNumber)
                    if (e.batchNo != e.batchNoNew) {
                        this.$message({
                            message: "批次号有变化，请先调整批次号！",
                            type: "warning",
                        });
                        return false;
                    } else if (e.boxCount == 0 || e.boxCount == "" || e.boxCount == null) {
                        this.$message({
                            message: "请填写箱数！",
                            type: "warning",
                        });
                        return false;
                    } else if (e.boxCount > 10) {
                        this.$message({
                            message: "最大箱数不能超过10箱!",
                            type: "warning",
                        });
                        return false;
                    } else if(e.boxNumber == "" || e.boxNumber == 0 || e.boxNumber == null){
                        this.$message({
                            message: "请填写每箱数量！",
                            type: "warning",
                        });
                        return false;
                    } else if((e.boxCount * e.boxNumber) > e.matQuan){
                        this.$message({
                            message: "添加库存数量不能超过该库存数量！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.checkLists.forEach(e =>{
                    if (e.boxBarcode != e.boxBarcodeNew) {
                        e.singletonFlag = true
                    }else{
                        e.singletonFlag = false
                    }
                    
                })
                this.$confirm("是否确认添加库存?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/inventory/insertVirtualInventory",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    whCode: localStorage.getItem("whCode")
                                },
                                data: this.checkLists,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.setReturnInfo();
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "SysLocation：添加库存成功";

                                    //退料条码打印
                                    var whinventoryList = resp.data;
                                    for (var index in whinventoryList) {
                                        var whData = whinventoryList[index];
                                        var produceTime = moment(whData.createTime).format("YYYYMMDD");
                                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                        // var qrCode = "T/" + "" + "/" + whData.boxBarcode + "/" + whData.matCode + "/" +
                                        //     whData.matQuan + "/" + whData.matSpecs + "/" + whData.newBatchNo +
                                        //     "/" + produceTime + "/" + whData.boxHeight;

                                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                        var qrCode = whData.boxBarcode + "," + whData.orderCode + "," + whData.whCode + "," +
                                            whData.matCode + "," + whData.matQuan + "," + whData.matSpecs +
                                            "," + whData.batchNo + "," + produceTime + "," + whData.boxHeight + ",,,";
                                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                        var barcodeData = {
                                            boxBarcode: whData.boxBarcode,
                                            poCode: whData.orderCode,
                                            prodCode: whData.matCode,
                                            prodName: whData.matName,
                                            batchNo: whData.batchNo,
                                            count: whData.matQuan,
                                            checkPerson: localStorage.getItem("empNumber"),
                                            date: produceTime,
                                            matSpecs: whData.matSpecs,
                                            whCode: whData.whCode,
                                            qrCode: qrCode,
                                            printTime: printTime,
                                        }
                                        this.$printer.printWMSReturnBarcode(barcodeData);
                                    }
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "SysLocation：添加库存失败";
                                }
                                this.logContent = JSON.stringify(this.checkLists);
                                this.systemLog();
                                //刷新数据
                                this.getVirtualInventory();
								
                                this.getStockPickList();
                            })
                    })
                    .catch(() => {
                        this.insertInventoryLists = false;
                        this.$message({
                            type: "info",
                            message: "已取消保存",
                        });
                    });
            },
            //虚拟库存多选
            selection(val) {
                this.checkLists = val;
            },

            //清空打印数据
            clearPrintData() {
                this.printList = [];
                this.summarySumNumber = 0;
                this.sumNumber = 0;
                this.boxNumber = 0;
            },

            /**
             * 根据产线点的箱号查询所在位置
             */
            getPointByBoxBarcode() {
                this.$http
                    .request({
                        url: "/api/prodTask/getPointByBoxBarcode",
                        method: "GET",
                        params: {
                            boxBarcode: this.checkListMains[0].boxBarcode || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.returnInfo.lcCode = resp.data.list[0].routerCode || null;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //IA-根据交易类型获取数据
            getTransaction() {
                this.$http
                    .request({
                        url: "/api/transaction/getTransactionAll",
                        method: "GET",
                        params: {
                            transactionType: "IA",
                            pageNum: 1,
                            pageSize: 100,
                            reasonCode: ''
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.transationReasonData = resp.data.list || [];
                            this.tablecause = "2352";
                        }
                    })
                    .catch((error) => {
                        
                    });
            },
            /**
             * 根据用户的工厂编号和通道编号查询所在的产线也就是库位编号
             */
            getLcCodeAllByWhCode() {
                this.$http
                    .request({
                        url: "/api/sysLineRouter/getLcCodeAllByReturnAndInput",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.sysLineRouterList = resp.data || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 修改
             */
            updateDetails(row) {
                if (row.recordStatus == "系统接受") {
                    this.$message({
                        message: "该数据不能修改",
                        type: "warning",
                    });
                    return;
                }
                this.disabled = true;
                this.onlineDialog = true;
                this.onlineInfo = row;
            },

            /**
             * 关闭任务-只能关闭创建状态的
             */
            closeTask() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "没有选择内容",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkListMain.every(e => {
                    if (e.spStatus != 'CREATE') {
                        this.$message({
                            message: "只能选择创建状态的任务！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }

                let smCodes = "";
                this.checkListMain.forEach((e) => {
                    smCodes = smCodes + e.sfpCode + ",";
                })

                this.$confirm("是否确认关闭?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockReturnMat/closeTask",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    smCodes: smCodes,
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                                //刷新数据
                                this.getSemiFinishedProductPage();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消退料",
                        });
                    });
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.getStockPickList();
                }, 1000);
            },

            // 节流搜索
            returnMatSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.getSemiFinishedProductPage();
                }, 1000);
            },
            /**
             * 退货原因
             * */
            getWarnType() {
                this.$http
                    .request({
                        url: "/api/warnType/getWarnType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            wtType: "30",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warnTypeList = resp.data;
                        }
                    })
                    .catch((error) => {});
            },
            /**
             * 驳回接收
             */
            insertRejectReceipt() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "没有选择内容",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkListMain.every(e => {
                    if (e.spStatus != "REJECT") {
                        this.$message({
                            message: "该状态不能被接收",
                            type: "warning",
                        });
                        return false;
                    }else{
                        return true;
                    }
                    // else if(e.distrType != "20"){
                    //     this.$message({
                    //         message: "AGV退料不能被接收",
                    //         type: "warning",
                    //     });
                    //     return false;
                    // } else {
                    //     return true;
                    // }
                })
                if (res == false) {
                    return false;
                }
                this.$confirm("是否驳回接收?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockReturnMat/insertRejectReceipt",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                                data: this.checkListMain
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockReturnMat：驳回接收成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockReturnMat：驳回接收失败";
                                }
                                this.logContent = JSON.stringify(this.checkListMain);
                                this.systemLog();
                                //刷新数据
                                this.getSemiFinishedProductPage();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消接收",
                        });
                    });
            },
            /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 判断是否是共享通道
             */
            getShareWhCode(){
                this.$http
                    .request({
                        url: "/api/sysWarehouse/getShareWhCode",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if(resp.data.total != 0){
                                this.shareWhCodeFlag = true;   
                            }else{
                                this.shareWhCodeFlag = false;
                            }

                            //所有通道查询时需要添加 54 ,DLN  53
                            var fcCode = localStorage.getItem("fcCode");

                            var whCode = localStorage.getItem("whCode");

                            var lcCode = "SEMI" + whCode;

                            // if(fcCode == "SXC"){
                            //     // whCode += ",54";
                            //     lcCode += ",WIP54"
                            // }else if(fcCode == "DLN" && !this.shareWhCodeFlag){
                            //     // whCode += ",53";
                            //     lcCode += ",WIP53"
                            // }else if(fcCode == "DLN" && this.shareWhCodeFlag){
                            //     //查询所有的共享库位
                            //     this.getShareLcCodeByFcCode();
                            // }

                            if(fcCode != "DLN" || !this.shareWhCodeFlag){
                                this.$http
                                    .request({
                                        url: "/api/inventory/getSemiInventory",
                                        method: "GET",
                                        showLoading: true,
                                        params: {
                                            //whCode: whCode,
                                            matCode: this.tableMatName || null,
                                            lcCode: lcCode || "",
                                        },
                                    })
                                    .then((resp) => {
                                        this.loading = false;
                                        if (resp.status == 100) {
                                            if (resp.data.list == null) {
                                                this.$message({
                                                    message: "暂无数据",
                                                    type: "warning",
                                                });
                                            }
                                            this.virtualInventoryList = resp.data.list;
                                            for (let e of this.virtualInventoryList) {
                                                this.$set(e, "boxNumber", 0);
                                                this.$set(e, "boxCount", 0);
                                                this.$set(e, "batchNoNew", e.batchNo);
                                                this.$set(e, "boxBarcodeNew", e.boxBarcode);
                                            }

                                            this.virtualInventoryAllList = this.virtualInventoryList;
                                        }	
                                    })
                                    .catch((error) => {
                                        this.loading = false;
                                    });
                            }

                            
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 根据工厂获取所有的共享库位
             */
            getShareLcCodeByFcCode(){
                this.$http
                    .request({
                        url: "/api/location/getShareLcCodeByFcCode",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.shareLcCodeList = resp.data.list || [];

                            var lcCode = "";
                            this.shareLcCodeList.forEach((item)=>{
                                lcCode += item.lcCode + ",";
                            })

                            this.$http
                                .request({
                                    url: "/api/inventory/getXNWIPInventory",
                                    method: "GET",
                                    showLoading: true,
                                    params: {
                                        matCode: this.tableMatName || null,
                                        lcCode: lcCode || "",
                                    },
                                })
                                .then((resp) => {
                                    this.loading = false;
                                    if (resp.status == 100) {
                                        if (resp.data.list == null) {
                                            this.$message({
                                                message: "暂无数据",
                                                type: "warning",
                                            });
                                        }
                                        this.virtualInventoryList = resp.data.list;
                                        for (let e of this.virtualInventoryList) {
                                            this.$set(e, "boxNumber", 0);
                                            this.$set(e, "boxCount", 0);
                                            this.$set(e, "batchNoNew", e.batchNo);
                                            this.$set(e, "boxBarcodeNew", e.boxBarcode);
                                        }

                                        this.virtualInventoryAllList = this.virtualInventoryList;
                                    }	
                                })
                                .catch((error) => {
                                    this.loading = false;
                                });
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 获取虚拟库存
             */
            getVirtualInventory() {

                var whCode = localStorage.getItem("whCode");

                var lcCode = "";

                if(whCode == undefined || whCode == ''){
                    this.$message({
                        message: "请使用通道账号进行查看",
                        type: "warning",
                    });
                    return;
                }

                this.dialogShowVirtual = true

                //所有通道查询时需要添加 54 ,DLN  53
                var fcCode = localStorage.getItem("fcCode");

                //判断是否是一厂的共享通道
                this.getShareWhCode();

            },


            /**
             * 生成条码
             */
            insertStockPrintBarcode() {
                if (this.checkListMainss.length == 0) {
                    this.$message({
                        message: "请选择数据",
                        type: "warning",
                    });
                    return;
                }
                this.insertStockPrintBarcodes = true;
                this.$http
                    .request({
                        url: "/api/inventory/insertStockPrintBarcode",
                        method: "POST",
                        showLoading: true,
                        params: {
                            person: localStorage.getItem("user") || "",
                            personNumber: localStorage.getItem("empNumber") || null,
                        },
                        data: this.checkListMainss,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.logRemarks = "inventory：生成条码新增成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: "新增失败",
                            });
                            this.logRemarks = "inventory：生成条码新增失败";
                        }
                        this.insertStockPrintBarcodes = false;
                        // this.systemLog();
                        // this.closeonlineDailog();
                        // this.getSysLocationPage();
                    })
            },

            /**
             * 根据工厂编号查找信息
             */
            getSysFactory() {
                this.$http
                    .request({
                        url: "/api/factory/getSysFactory",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || ""
                        },
                    })
                    .then((resp) => {
                        this.factory = resp.data;
                        if (this.factory.distrType == true) {
                            this.returnInfo.distrType = "10"
                        } else {
                            this.returnInfo.distrType = 20
                        }

                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            selectWipOutInventory(val) {
                this.wipOutSelectList = val;
            },

            /**
             * 通道库中的箱号下拉框
             */
            getBoxBarcodeList(matCode) {

                if (this.wipMatCode) {
                    matCode = this.wipMatCode;
                }

                this.$http
                    .request({
                        url: "/api/location/getBoxBarcodeList",
                        method: "GET",
                        params: {
                            pageNum: this.returnSearch.nowPage, //	页号
                            pageSize: this.returnSearch.pageSize, //	页大小
                            matCode: matCode,
                            whCode: localStorage.getItem("whCode") || "",
                            beginTime: this.returnInfo.date ?
                                this.returnInfo.date[0] : null,
                            endTime: this.returnInfo.date ?
                                this.returnInfo.date[1] : null,
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.BoxBarcodeLists = resp.data.list || [];
                            this.wipOutInventoryList = resp.data.list || [];
                            this.returnSearch.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 通道库出库记录,查询最近100条
             */
            getInventoryRecords() {
                this.$http
                    .request({
                        url: "/api/inventoryRecord/getBoxList",
                        method: "GET",
                        params: {
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.BoxBarcodeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            chackBox(item) {
                this.$http
                    .request({
                        url: "/api/mes/chackBox",
                        method: "GET",
                        params: {
                            whCode: this.returnInfo.whCode || null,
                            boxBarcode: item,
                            wirType: "OUT",
                            lcType: "WIP"
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.returnLists = resp.data || [];
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 线上物料退回
             */
            onlineMaterialReturn() {
                this.onlineDialog = true;
            },

            /**
             * 获取生产退料信息-退料单
             */
            getSemiFinishedProductPage() {
                this.$http
                    .request({
                        url: "/api/semiFinishedProduct/getSemiFinishedProductPage",
                        method: "GET",
                        params: {
                            pageNum: this.mainSearch.nowPage,
                            pageSize: this.mainSearch.pageSize,
                            fcCode: this.mainSearch.fcCode || null,
                            whCode: this.mainSearch.whCode || null,
                            sfpCode: this.mainSearch.sfpCode || null,
                            matCode: this.mainSearch.matCode || null,
                            boxBarcode: this.mainSearch.boxBarcode || null,
                            status: this.mainSearch.status || null,
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData.data = resp.data.list;
                            this.mainData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 修改
             */
            updateDetail(row) {
                this.disabled = true;
                this.onlineDialog = true;
                this.onlineInfo = row;
            },

            //线上物料退回确定
            operationOnline() {
                if (this.disabled == false) {
                    let info = {
                        whCode: localStorage.getItem("whCode") || "",
                        fcCode: localStorage.getItem("fcCode") || "",
                        matCode: this.onlineInfo.matCode,
                        boxBarcode: this.onlineInfo.boxBarcode,
                        matQuan: this.onlineInfo.matQuan,
                        batchNo: this.onlineInfo.batchNo,
                        matSpecs: this.onlineInfo.matSpecs,
                        matLenValue: this.onlineInfo.matLenValue,
                        position: this.onlineInfo.position,
                        validityMonth: this.onlineInfo.validityMonth,
                        matCreateTime: this.onlineInfo.matCreateTime,
                    }
                    this.$http
                        .request({
                            url: "/api/inventory/insertInventory",
                            method: "POST",
                            showLoading: true,
                            params: {
                                person: localStorage.getItem("user") || "",
                                personNumber: localStorage.getItem("empNumber") || null,
                            },
                            data: info,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "inventory：库存新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "新增失败",
                                });
                                this.logRemarks = "inventory：库存新增失败";
                            }
                            this.systemLog();
                            this.closeonlineDailog();
                            this.getSysLocationPage();
                        })
                } else {
                    this.$http
                        .request({
                            url: "/api/inventory/updateInventory",
                            method: "POST",
                            showLoading: true,
                            data: this.onlineInfo,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "location：编辑成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "修改失败",
                                });
                                this.logRemarks = "location：编辑失败";
                            }
                            this.closeonlineDailog();
                            this.getSysLocationPage();
                            this.systemLog();

                        })

                }
            },

            //删除库存数量
            deliveryDetail(row) {
                if (row.recordStatus == "系统接受") {
                    this.$message({
                        message: "该数据不能修改",
                        type: "warning",
                    });
                    return;
                }
                this.$http
                    .request({
                        url: "/api/location/deleteWhInventory",
                        method: "Delete",
                        params: {
                            wiId: row.wiId,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "操作成功！",
                                type: "success",
                            });
                        }
                        this.closeonlineDailog();
                        this.getStockPickList();
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },


            /**
             * 查询当前配送未使用的物料信息
             */
            getStockPickList() {
                this.$http
                    .request({
                        url: "/api/location/getSysLocationSemiPage",
                        method: "GET",
                        params: {
                            matCode: this.mainSearchMat.matCode || null,
                            boxBarcode: this.mainSearchMat.boxBarcode || null,
                            matSpecs: this.mainSearchMat.matSpecs || null,
                            matLenValue: this.mainSearchMat.matLenValue || null,
                            whCode: this.mainSearchMat.whCode || null,
                            fcCode: this.mainSearchMat.fcCode || null,
                            lrPointType: this.mainSearchMat.lrPointType || null,
                            pageNum: this.mainSearchMat.nowPage,
                            pageSize: this.mainSearchMat.pageSize,
                            lcCode: this.mainSearchMat.lcCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.nextData.data = resp.data.list || [];
                            this.nextData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {});
            },

            /**
             * 获取生产退料信息-退料单明细
             */
            getStockReturnMatList() {
                this.$http
                    .request({
                        url: "/api/stockReturnMat/getStockReturnMatList",
                        method: "GET",
                        params: {
                            pageNum: this.detailData.nowPage,
                            pageSize: this.detailData.pageSize,
                            sfpCode: this.detailData.sfpCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.detailData.data = resp.data.list || [];
                            this.detailData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 新增退料
             */
            insertDialog() {
                this.dialogShow = true;
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    whCodeBack: "",
                    wtName: "",
                    boxQuan: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    date: [],
                };
            },

            /**
             * 新增通道库存
             */
            insertDialogs() {
                this.dialogShows = true;
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    whCodeBack: "",
                    wtName: "",
                    boxQuan: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    matCodes: "",
                    date: [],
                };
                //添加默认时间
                    this.returnInfo.date = [];
                    this.returnInfo.date.push(moment().subtract(7, 'd').format('YYYY-MM-DD HH:mm:ss'));
                    this.returnInfo.date.push(moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss'));
                this.getBoxBarcodeList("");
            },
            /**
             * 上线使用
             */
            onlineUse() {
                if (this.checkListMains.length == 0) {
                    this.$message({
                        message: "请勾选通道物料！",
                        type: "warning",
                    });
                    return;
                }
                for(var index in this.checkListMains) {
                    if (this.checkListMains[index].lcType == null || this.checkListMains[index].lcType != 'SEMI') {
                        this.$message({
                            message: "该物料不是SEMI半成品库存",
                            type: "warning",
                        });
                        return;
                    }
                    if (this.checkListMains[index].receiptResult != "" && this.checkListMains[index].receiptResult != undefined) {
                        this.$message({
                            message: "只能对没有入库的半成品库存数据进行上线使用！",
                            type: "warning",
                        });
                        return;
                    }
                }
                this.$http
                    .request({
                        url: "/api/warehouse/onlineUse",
                        method: "POST",
                        showLoading: true,
                        data: this.checkListMains,
                        params: {
                            person: localStorage.getItem("user") || "",
                            personNumber: localStorage.getItem("empNumber") || null
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                            this.logRemarks = "order：上线使用成功";
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                            this.logRemarks = "order：上线使用失败";
                        }
                        this.logContent = JSON.stringify(this.checkListMains);
                        this.systemLog();
                        //刷新数据
                        this.getStockPickList();
                        this.getSemiFinishedProductPage();
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            insertSemi() {
                if (this.checkListMains.length == 0) {
                    this.$message({
                        message: "请选择要入库的半成品库存",
                        type: "warning",
                    });
                    return;
                }
                // else if (this.checkListMains.length != 1) {
                //     this.$message({
                //         message: "只能对一箱物料进行退料操作",
                //         type: "warning",
                //     });
                //     return;
                // }
                this.getLcCodeAllByWhCode();
                //this.getPointByBoxBarcode();
                var map = [];
                this.dataList.forEach((e) => {
                    map.push(e.boxBarcode);
                })
                const res = this.checkListMains.every(e => {
                    if (map.indexOf(e.boxBarcode) > 0) {
                        this.$message({
                            message: "该物料已退料",
                            type: "warning",
                        });
                        return false;
                    } else if (e.receiptResult != undefined && e.receiptResult != "") {
                        this.$message({
                            message: "只能对需要入库的半成品库存进行入库！",
                            type: "warning",
                        });
                        return;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    date: [],
                    whCodeBack: "",
                    wtName: "",
                    lcCode: "",
                };
                var whCodelist = [];
                this.checkListMains.forEach((e) => {
                    whCodelist.push(e.whCode);
					e.matSpeces = e.matSpecs
                })
                if(whCodelist.includes("01") || this.fcCode=="DLN"){
                    this.$set(this.returnInfo,"distrType","20")
                }else{
                    this.$set(this.returnInfo,"distrType","10")
                }
                this.resd = 1;
                this.dialogShow = true;
                this.returnList = this.checkListMains;

            },

            closeDailog() {
                this.dialogShow = false;
                this.returnList = [];
            },

            closeDailogs() {
                this.dialogShows = false;
                this.returnLists = [];
                this.insetadd = 0
            },

            closeonlineDailog() {
                this.onlineDialog = false;
                this.onlineInfo = {};
                this.disabled = false;
            },

            //添加库存-填写保存
            getInventory() {
                if (this.returnInfo.matCode == "" || this.returnInfo.matCode == null) {
                    this.$message({
                        message: "物料编号不能为空",
                        type: "warning",
                    });
                    return;
                }
                if (this.returnInfo.matName == "" || this.returnInfo.matName == null) {
                    this.$message({
                        message: "物料描述不能为空",
                        type: "warning",
                    });
                    return;
                }
                if (this.returnInfo.boxQuan == "" || this.returnInfo.boxQuan == null) {
                    this.$message({
                        message: "数量不能为空",
                        type: "warning",
                    });
                    return;
                }
                if (this.returnInfo.matSpecs == "" || this.returnInfo.matSpecs == null) {
                    this.$message({
                        message: "规值不能为空",
                        type: "warning",
                    });
                    return;
                }
                let info = {
                    matCode: this.returnInfo.matCode || null,
                    matName: this.returnInfo.matName || null,
                    matQuan: this.returnInfo.boxQuan || null,
                    batchNo: null,
                    boxBarcode: null,
                    fcCode: localStorage.getItem("fcCode") || "",
                    person: localStorage.getItem("user") || "",
                    personNumber: localStorage.getItem("empNumber") || null,
                    whCode: this.returnInfo.whCode || null,
                    matSpecs: this.returnInfo.matSpecs || null,
                    matLenValue: this.returnInfo.matLenValue || null,
                };
                this.returnLists.push(info);


                this.returnInfo = {
                    matCode: "",
                    matName: "",
                    boxQuan: "",
                    boxBarcode: "",
                    whCode: localStorage.getItem("whCode") || "",
                    matSpecs: "",
                    matLenValue: "",
                    matCodes: ""
                };
            },
            // 根据箱号获取料箱信息
            getInventoryByBoxcode() {
                if (this.submitForm("returnInfo")) {
                    let aa = this.returnList.find(
                        (element) => element.boxBarcode == this.returnInfo.boxBarcode
                    );
                    if (aa) {
                        this.$message({
                            message: "料箱已存在",
                            type: "warning",
                        });
                        return;
                    }
                    this.$http
                        .request({
                            url: "api/stockReturnMat/getInventoryByBoxcode",
                            method: "GET",
                            showLoading: true,
                            params: {
                                boxBarcode: this.returnInfo.boxBarcode,
                            },
                        })
                        .then((res) => {
                            if (res.status == 100) {
                                if (res.data.matQuan < this.returnInfo.boxQuan) {
                                    this.$message({
                                        message: "退料数量已大于料箱原本物料数",
                                        type: "warning",
                                    });
                                    return;
                                }
                                let info = {
                                    matCode: res.data.matCode,
                                    matName: res.data.matName,
                                    matQuan: this.returnInfo.boxQuan,
                                    matQuanOld: res.data.matQuan,
                                    boxBarcode: res.data.boxBarcode,
                                    batchNo: res.data.batchNo,
                                    fcCode: res.data.fcCode,
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                    whCode: res.data.whCode,
                                    whCodeBack: this.returnInfo.whCodeBack,
                                    bsCode: this.returnInfo.bsCode,
                                    wtName: this.returnInfo.wtName,
                                };
                                this.returnList.push(info);
                            } else {
                                this.$message.error(res.message);
                            }
                            this.returnInfo = {
                                whCode: localStorage.getItem("whCode") || "",
                                boxBarcode: "",
                                bsCode: "",
                                matCode: "",
                                whCodeBack: "",
                                wtName: "",
                                boxQuan: "",
                                matName: "",
                                matSpecs: "",
                                matLenValue: "",
                                matCodes: ""
                            };
                        });
                }
            },
            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            againResubmit() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "没有选择内容",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkListMain.every(e => {
                    if (e.spStatus != "REJECT") {
                        this.$message({
                            message: "请选择已驳回的数据",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.getLcCodeAllByWhCode();
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    whCodeBack: "",
                    wtName: "",
                    lcCode: "",
                    distrType: "",
                    date: [],
                };
                this.resubmitShow = true;
            },

            judge() {
                this.$http
                    .request({
                        url: "/api/semiFinishedProduct/getSemiFinishedProductPage",
                        method: "GET",
                        params: {
                            pageNum: this.mainData.nowPage,
                            pageSize: this.mainData.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.dataList = resp.data.list || []
                        }
                    })

            },
            /**
             * 退料
             */
            insertSemiFinishedProduct() {
                if (this.returnList.length == 0) {
                    this.$message({
                        message: "没有内容",
                        type: "warning",
                    });
                    return;
                }
                this.returnInfo.distrType = '20';
                if (this.resd == 1) {
                    
                    if (this.returnInfo.distrType == "") {
                        this.$message({
                            message: "请选择配送方式",
                            type: "warning",
                        });
                        return;
                    }
                    if(this.mainSearchMat.fcCode == 'DLN'){
                        if(this.returnInfo.boxBarcode == ""){
                            var boxList = [];
                            this.returnList.forEach((e) => {
                                boxList.push(e.boxBarcode);
                            });
                            if(boxList.indexOf(this.returnInfo.boxBarcode) <= -1){
                                this.$message({
                                    message: "该圈号不存在以下数据中！",
                                    type: "warning",
                                });
                                return;
                            }
                        }
                
                    }
                    // if (this.returnInfo.whCodeBack == "") {
                    //     this.$message({
                    //         message: "请选择退回通道",
                    //         type: "warning",
                    //     });
                    //     return;
                    // }
                    // if (this.returnInfo.wtName == "") {
                    //     this.$message({
                    //         message: "请选择退回原因",
                    //         type: "warning",
                    //     });
                    //     return;
                    // }
                    if (this.returnInfo.distrType == 10) {
                        if (this.returnInfo.lcCode == "") {
                            this.$message({
                                message: "请选择库位编号",
                                type: "warning",
                            });
                            return;
                        } 
                        // else if (this.returnInfo.boxHeight == "") {
                        //     this.$message({
                        //         message: "请选择箱体高度",
                        //         type: "warning",
                        //     });
                        //     return;
                        // }
                    }
                    var whCodelist = [];
                    this.returnList.forEach((e) => {
                        whCodelist.push(e.whCode);
                    })
                    // if(whCodelist.includes("01")){
                    //     this.$message({
                    //             message: "01通道无AGV配送方式！",
                    //             type: "warning",
                    //         });
                    //         return;
                    // }
                    this.returnList.forEach((e) => {
                        if (this.returnInfo.distrType == '10') {
                            //AGV 库位未当前选中的库位
                            e.laCodeReturn = this.returnInfo.lcCode;
                        } else {
                            //人工默认当前WIP库位
                            e.laCodeReturn = e.lcCode;
                        }
                        
                        e.laCode = e.lcCode;
                        e.distrType = this.returnInfo.distrType;
                        e.whCodeBack = this.returnInfo.whCodeBack;
                        e.wtName = this.returnInfo.wtName;
                        // e.boxHeight = this.returnInfo.boxHeight;
                    });

                }

                this.$confirm("是否确认入库?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.insertStockReturnMats = true;
                        this.$http
                            .request({
                                url: "/api/semiFinishedProduct/insertSemiFinishedProduct",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    whCode: localStorage.getItem("whCode")
                                },
                                data: this.returnList,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockReturnMat：确认半成品入库成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockReturnMat：确认半成品入库失败";
                                }

                                var printList = this.returnList;

                                this.insertStockReturnMats = false;
                                this.logContent = JSON.stringify(this.returnList);
                                this.systemLog();
                                //刷新数据
                                this.getStockPickList();
                                this.closeDailog();
                                this.getSemiFinishedProductPage();

                                for (var index in printList) {

                                    var whData = printList[index];
                                    var produceTime = moment(whData.createTime).format("YYYYMMDD");

                                    //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                    // var qrCode = "T/" + "" + "/" + whData.boxBarcode + "/" + whData.matCode + "/" +
                                    //     whData.matQuan + "/" + whData.matSpecs + "/" + whData.newBatchNo +
                                    //     "/" + produceTime + "/" + whData.boxHeight;

                                    //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                    var qrCode = whData.boxBarcode + "," + whData.orderCode + "," + whData.whCode + "," +
                                        whData.matCode + "," + whData.matQuan + "," + whData.matSpecs +
                                        "," + whData.newBatchNo + "," + produceTime + "," + ",,,";


                                    var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                    var barcodeData = {
                                        boxBarcode: whData.boxBarcode,
                                        poCode: whData.orderCode,
                                        prodCode: whData.matCode,
                                        prodName: whData.matName,
                                        batchNo: whData.batchNo,
                                        count: whData.matQuan,
                                        checkPerson: localStorage.getItem("empNumber"),
                                        date: produceTime,
                                        matSpecs: whData.matSpecs,
                                        whCode: whData.whCode,
                                        qrCode: qrCode,
                                        printTime: printTime,
                                        remark: whData.remark
                                    }

                                    //this.$printer.printWMSReturnBarcode(barcodeData);
                                }
                            })
                            .catch((error) => {
                                this.insertStockReturnMats = false;
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.insertStockReturnMats = false;
                        this.$message({
                            type: "info",
                            message: "已取消半成品入库",
                        });
                    });
            },
            /**
             * 重置
             */
            setStockReturnMat(){
                this.returnInfo = {
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    whCodeBack: "",
                    wtName: "",
                    boxQuan: "",
                    lcCode: "",
                    distrType: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    matCodes: "",
                    boxHeight: ""
                };
            },
            /**
             *  新增库存
             */
            insertInventoryList() {
                if (this.wipOutSelectList.length == 0) {
                    this.$message({
                        message: "没有选择数据,请先选择数据",
                        type: "warning",
                    });
                    return;
                }
                this.insertInventoryLists = true;
                this.$confirm("是否确认添加库存?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/inventory/insertInventoryList",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                                data: this.wipOutSelectList,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.setReturnInfo();
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "SysLocation：添加库存成功";

                                    //退料条码打印
                                    var whinventoryList = resp.data;
                                    for (var index in whinventoryList) {
                                        var whData = whinventoryList[index];
                                        var produceTime = moment(whData.createTime).format("YYYYMMDD");
                                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                        // var qrCode = "T/" + "" + "/" + whData.boxBarcode + "/" + whData.matCode + "/" +
                                        //     whData.matQuan + "/" + whData.matSpecs + "/" + whData.newBatchNo +
                                        //     "/" + produceTime + "/" + whData.boxHeight;

                                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                        var qrCode = whData.boxBarcode + "," + whData.orderCode + "," + whData.whCode + "," +
                                            whData.matCode + "," + whData.matQuan + "," + whData.matSpecs +
                                            "," + whData.newBatchNo + "," + produceTime + "," + ",,,";
                                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                        var barcodeData = {
                                            boxBarcode: whData.boxBarcode,
                                            poCode: whData.orderCode,
                                            prodCode: whData.matCode,
                                            prodName: whData.matName,
                                            batchNo: whData.batchNo,
                                            count: whData.matQuan,
                                            checkPerson: localStorage.getItem("empNumber"),
                                            date: produceTime,
                                            matSpecs: whData.matSpecs,
                                            whCode: whData.whCode,
                                            qrCode: qrCode,
                                            printTime: printTime,
                                        }
                                        this.$printer.printWMSReturnBarcode(barcodeData);
                                    }
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "SysLocation：添加库存失败";
                                }
                                this.insertInventoryLists = false;
                                this.logContent = JSON.stringify(this.returnLists);
                                this.systemLog();
                                //刷新数据
                                
                                this.getStockPickList();
                                this.closeDailogs();
                            })
                        // .catch((error) => {
                        //     this.insertInventoryLists = false;
                        //     this.$message({
                        //         message: "操作失败",
                        //         type: "warning",
                        //     });
                        // });
                    })
                    .catch(() => {
                        this.insertInventoryLists = false;
                        this.$message({
                            type: "info",
                            message: "已取消保存",
                        });
                    });
                                    
            },
            /**
             * 
             */
            setReturnInfo(){
                this.returnInfo = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    matCodes: "",
                    whCodeBack: "",
                    lcCode: "",
                    distrType: "",
                    wtName: "",
                    boxQuan: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    beginTime: "",
                    boxHeight: "",
                    date: [],
                };
            },
            

            heatNumberClick(row) {
                this.$set(row, "clicktext", true);
            },
            /**
             * 修改退料单备注
             */
            updateStockReturnMat(row) {
                this.$http
                    .request({
                        url: "/api/stockReturnMat/updateStockReturnMat",
                        method: "PUT",
                        showLoading: true,
                        data: row,
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.$set(row, "clicktext", false);
                            this.$message({
                                message: "提交成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
            },


            //标签打印
            rePrintBarcode() {
                this.printShow = true;
                this.checkPrint.daya = this.virtualInventoryList.map(ele=>{
                    if (ele.whCode) {
                        return ele;
                    }
                })
                this.checkAisle.daya = this.nextData.data.map(ele=>{
                    if (ele.whCode) {
                        return ele;
                    }
                })
                // if (this.checkLists.length == 0) {
                //     this.$message({
                //         message: "请勾选打印单！",
                //         type: "warning",
                //     });
                //     return;
                // }
                // //无码时添加打印限制
                // if (this.lazyNext) {
                //     this.$message.error('请五秒后再打印！')
                //     return
                // } else {
                //     this.checkLists.forEach((item) => {
                //         // let od = this.orderSearch.data.find(o => o.orderCode == item.orderCode);
                //         var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                //         //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                //         // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                //         // item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                //         // "/" + produceTime + "/";

                //         //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                //         var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                //             item.matCode + "," + item.matQuan + "," + item.matSpecs +
                //             "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                //         if (item.matSpecs == undefined) {
                //             item.matSpecs = "";
                //         }
                //         if (item.orderCode == undefined) {
                //             item.orderCode = "";
                //         }
                //         if (item.matSpecs == undefined) {
                //             item.matSpecs = "";
                //         }

                //         var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                //         var barcodeData = {
                //             boxBarcode: item.boxBarcode,
                //             prodCode: item.matCode,
                //             prodName: item.matName,
                //             batchNo: item.batchNo,
                //             count: item.matQuan,
                //             checkPerson: localStorage.getItem("empNumber"),
                //             date: produceTime,
                //             poCode: item.orderCode,
                //             matSpecs: item.matSpecs,
                //             whCode: item.whCode,
                //             qrCode: qrCode,
                //             supply: "",
                //             printTime: printTime
                //         }

                //         this.$printer.printWMSBarcode(barcodeData);
                //     })

                //     this.lazyNext = setTimeout(() => {
                //         this.lazyNext = null
                //     }, 5000)
                // }
            },



            /**
             * 明细
             */
            detailDialog(sfpCode) {
                this.detailShow = true;
                this.detailData.sfpCode = sfpCode;
                this.getStockReturnMatList();
            },
            closeDetailDailog() {
                this.detailShow = false;
            },

            /**
             * 多选
             */
            selectMain(val) {
                this.checkListMain = val;
            },

            selectNext(val) {
                this.checkListMains = val;
            },

            selectNexts(val) {
                this.checkListMainss = val;
            },
            //禁选
            checkboxSelect(row, rowIndex) {
                // if (row.spStatus == 'CREATE') {
                //     return true // 不禁用
                // } else {
                //     return false // 禁用
                // }
                return true;
            },
            /**
             * 重置
             */
            resetMain() {
                this.mainSearch = {
                    nowPage: 1,
                    pageSize: 50,
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    person: localStorage.getItem("user") || "",
                    sfpCode: "",
                    matCode: "",
                    boxBarcode: "",
                    status: "CREATE,WAIT,REJECT",
                    matSpecs: "",
                    matLenValue: "",
                    date: [],
                };
                this.getSemiFinishedProductPage();
                this.getStockPickList();
            },

            /**
             * 重置
             */
            resetTop() {
                this.mainSearchMat = {
                    nowPage: 1,
                    pageSize: 50,
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    sfpCode: "",
                    matCode: "",
                    boxBarcode: "",
                    status: "",
                    matSpecs: "",
                    matLenValue: "",
                    lrPointType: "",
                    date: [],
                };
                this.getStockPickList();
            },

            //表格导出
            downLoadFileMat() {
                this.downloadLoadingMat = true;
                var paramsObj = {
                    matCode: this.mainSearchMat.matCode || null,
                    boxBarcode: this.mainSearchMat.boxBarcode || null,
                    matSpecs: this.mainSearchMat.matSpecs || null,
                    matLenValue: this.mainSearchMat.matLenValue || null,
                    whCode: this.mainSearchMat.whCode || null,
                    fcCode: this.mainSearchMat.fcCode || null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/location/getSysLocationPage',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoadMat(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoadMat(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.wiStatus == 'NORMAL') {
                            c['wiStatus'] = '正常'
                        } else if (c.wiStatus == 'FREEZE') {
                            c['wiStatus'] = '冻结'
                        } else if (c.wiStatus == 'OVERTIME') {
                            c['wiStatus'] = '过期'
                        } else if (c.wiStatus == 'DELETE') {
                            c['wiStatus'] = '作废'
                        } else if (c.wiStatus == 'AGFREEZE') {
                            c['wiStatus'] = '人工冻结'
                        } else {
                            c['wiStatus'] = ''
                        }
                        
                         if (c.lrPointType == '10') {
                            c['lrPointType'] = '装配'
                        } else if (c.lrPointType == '20') {
                            c['lrPointType'] = '锻圈'
                        }
                    })

                    const tHeader = ['通道编号', '物料编号', '物料描述', '数量', '批次号', '货位号', '箱号', '规值', '入库时间', '位置类型', '地面位置',
                        '送达时间'
                    ]
                    const filterVal = ['whCode', 'matCode', 'matName', 'matQuan', 'batchNo', 'lcCode', 'boxBarcode', 'matSpecs', 'matCreateTime',
                        'lrPointType', 'routerCode', 'updateTime'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '通道物料'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory：导出通道物料记录"
                    this.systemLog();
                    this.downloadLoadingMat = false
                })
            },
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    fcCode: this.mainSearch.fcCode || null,
                    whCode: this.mainSearch.whCode || null,
                    sfpCode: this.mainSearch.sfpCode || null,
                    matCode: this.mainSearch.matCode || null,
                    boxBarcode: this.mainSearch.boxBarcode || null,
                    status: this.mainSearch.status || null,
                    beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                    endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/semiFinishedProduct/getSemiFinishedProductPage',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.spStatus == 'CREATE') {
                            c['spStatus'] = '创建'
                        } else if (c.spStatus == 'WAIT') {
                            c['spStatus'] = '待上架'
                        } else if (c.spStatus == 'REJECT') {
                            c['spStatus'] = '驳回'
                        } else if (c.spStatus == 'UPPERING') {
                            c['spStatus'] = '上架中'
                        }else if (c.spStatus == 'RECEiIVE') {
                            c['spStatus'] = '驳回已接收'
                        }else if (c.spStatus == 'CLOSE') {
                            c['spStatus'] = '关闭'
                        }else if (c.spStatus == 'CONFIRM') {
                            c['spStatus'] = '完成'
                        }

                        if (c.distrType == '20') {
                            c['distrType'] = '人工退料'
                        } else if (c.distrType == '10') {
                            c['distrType'] = 'AGV退料'
                        }
                    })
                    const tHeader = ['通道编号', '退料单号', '退料状态', '退料数量', '退料方式', '退料库位', '操作人员', '创建时间', '修改时间']
                    const filterVal = ['whCode', 'sfpCode', 'spStatus', 'matQuan', 'distrType','laCodeReturn', 'person', 'createTime', 'updateTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '生产退料'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_return_mat：导出生产退料记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            //打印

            /**
             * 全选
             */
            selectAllMain(val) {
                this.checkListMain = val;
            },

            /**
             * 禁选
             */
            checkboxMain(row, rowIndex) {
                // if (row.status == "CREATE") {
                return true; // 不禁用
                // } else {
                // return false; // 禁用
                // }
            },
            prints(sfpCode) {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择打印单！",
                        type: "warning",
                    });
                    return
                }
                let list = []
                this.checkListMain.forEach((item) => {
                    list.push(item.sfpCode)
                })
                var sfpCode = list.join(",")
                this.$http
                    .request({
                        url: "/api/stockReturnMat/getStockReturnMatList",
                        method: "GET",
                        params: {
                            sfpCode: sfpCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.list != null) {
                                this.printList = resp.data.list;
                                var matCode = resp.data.list[0].matCode || "";
                                this.printList.forEach((item, index) => {
                                    if (matCode == item.matCode) {
                                        this.sumNumber += item.matQuan;
                                    } else {
                                        matCode = item.matCode;
                                        this.summarySumNumber += this.sumNumber;
                                        this.sumNumber = item.matQuan;
                                    }
                                });
                                this.summarySumNumber += this.sumNumber;
                                this.boxNumber = resp.data.total;
                                this.workCenter = resp.data.list[0].workCenter
                                this.printShow = true;
                                this.getTime()

                            } else {
                                this.$message({
                                    message: "未找到打印记录！",
                                    type: "warning",
                                });
                                return
                            }
                        }
                    })
                    .catch((error) => {});
            },
            printObjList() {
                let code = [];
                for (let i in this.printList) {
                    code.push(this.printList[i].sorCode)
                }
                let stringCode = code.join(",")
                this.$http
                    .request({
                        url: "api/stockPrintDocument/insertStockPrintDocument",
                        method: "POST",
                        showLoading: true,
                        params: {
                            operaCode: stringCode,
                            operaType: '10',
                            fcCode: localStorage.getItem("fcCode") || "",
                            person: localStorage.getItem("user"),
                            personNumber: localStorage.getItem("empNumber"),
                        },
                    })
                    .then((resp) => {})
                    .catch((error) => {});
            },
            /**
             * 获取当前时间
             * 格式YYYY-MM-DD
             */
            getTime() {
                var date = new Date();
                var seperator1 = "/";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                this.timeDate = year + seperator1 + month + seperator1 + strDate;
            },

           

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "生产退料",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
            openTime(){
                this.timer = setInterval(() => {
                    this.getStockPickList();
                }, 600000);
            },

        },
        activated() {
            //添加默认时间
            this.mainSearch.date = [];
            this.mainSearch.date.push(moment().subtract('d', 1).format("YYYY-MM-DD HH:mm"));
            this.mainSearch.date.push(moment().add('d', 1).format("YYYY-MM-DD HH:mm"));
            this.getSemiFinishedProductPage();
            this.getWarehouse();
            this.getWarnType();
            this.getSysFactory();
            this.judge();
            /* 获取首页的数据 */
            this.getStockPickList();
            this.openTime();
        },
        deactivated(){
            clearTimeout(this.timer);
        },
    };
</script>
<style scoped>
    .div div {
        width: 170px;
        height: 50px;
        /* border: 1px solid black; */
        margin-left: 10px;
        margin-top: 10px;
        float: left;
        font-weight: 550;
        font-size: 18px;
    }

    /* .table table {
        margin-top: 3px;
    } */

    table tr th {
        width: 180px;
        border: 1px solid black;
        font-size: 16px;
        text-align: center;
        color: black;
    }

    table tr td{
        width: 180px;
        border: 1px solid black;
        font-size: 14px;
        text-align: center;
        color: black;
    }

    .color {
        background: rgb(194, 192, 192);
        color: black;
    }

    .breaditem {
        background-color: #ecf5ff;
    border-color: #d9ecff;
    display: inline-block;
        border: 1px solid;
        width: auto;
        color: #409EFF;
        font-size: 12px;
        height: 20px;
    padding: 0 5px;
    line-height: 19px;
    cursor: pointer;
    display: inline-block;
    border-radius: 4px;
    margin-left: 10px;
    }

    .div span {
  margin-left: 50px;
}

.table table {
  margin-top: 20px;
}

.table table tr td {
  width: 100px;
  height: 50px;
  border: 1px solid black;
  text-align: center;
}

.table table tr th {
  width: 100px;
  height: 80px;
  border: 1px solid black;
  font-weight: 800;
  font-size: 18px;
}

.td td {
  font-weight: 800;
}

.btnCircle {
  padding: 5px !important;
  height: auto !important;
  font-size: 12px !important;
}
</style>